import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { dispatch } from 'store';
import { createActionDispatcher } from 'store/create-action-dispatcher';
import { ChatUserModel } from 'types/chat-users/chat-user';
import { fetcher } from 'utils/axios';

interface UnreadCounts {
  allUnreadCount: number;
  myUnreadCount: number;
  notMyUnreadCount: number;
  noAssigneeUnreadCount: number;
  botActiveUnreadCount: number;
}

const initialState: UnreadCounts = {
  allUnreadCount: 0,
  myUnreadCount: 0,
  notMyUnreadCount: 0,
  noAssigneeUnreadCount: 0,
  botActiveUnreadCount: 0,
};

const unreadChatUsersSlice = createSlice({
  name: 'unreadChatUsers',
  initialState,
  reducers: {
    storeSetUnreadChatUsers: (state, action: PayloadAction<UnreadCounts>) => {
      return action.payload;
    },
    storeClearUnreadChatUsers: () => {
      return initialState;
    },
    storeDecrementLegacyUnreadBucket: (
      state,
      action: PayloadAction<{ chatUser: ChatUserModel; currentUserUdid?: string }>,
    ) => {
      const { chatUser, currentUserUdid } = action.payload;
      if ((chatUser.UnreadMessagesNumber ?? 0) <= 0) return;

      state.allUnreadCount = Math.max(0, state.allUnreadCount - 1);

      const assignee = chatUser.NotificationContactUser;
      if (!assignee) {
        state.noAssigneeUnreadCount = Math.max(0, state.noAssigneeUnreadCount - 1);
      } else if (assignee === currentUserUdid) {
        state.myUnreadCount = Math.max(0, state.myUnreadCount - 1);
      } else {
        state.notMyUnreadCount = Math.max(0, state.notMyUnreadCount - 1);
      }

      if (chatUser.isBot) {
        state.botActiveUnreadCount = Math.max(0, state.botActiveUnreadCount - 1);
      }
    },
  },
});

export default unreadChatUsersSlice.reducer;
export const { storeSetUnreadChatUsers, storeClearUnreadChatUsers, storeDecrementLegacyUnreadBucket } =
  unreadChatUsersSlice.actions;

export const setUnreadChatUsers = createActionDispatcher(storeSetUnreadChatUsers);
export const getUnreadChatUsers = async () => {
  try {
    const data = await fetcher('get', '/api/services/getUnreadChatUsers', 'api');
    if (data) {
      dispatch(
        storeSetUnreadChatUsers({
          allUnreadCount: data.allUnreadCount || 0,
          myUnreadCount: data.myUnreadCount || 0,
          notMyUnreadCount: data.notMyUnreadCount || 0,
          noAssigneeUnreadCount: data.noAssigneeUnreadCount || 0,
          botActiveUnreadCount: data.botActiveUnreadCount || 0,
        }),
      );
    }
  } catch (error) {
    console.warn('Error fetching chat users:', error);
  }
};
export const clearUnreadChatUsers = createActionDispatcher(storeClearUnreadChatUsers);
